/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Home_Faq_2Inputs */

const en_settings_home_faq_2 = /** @type {(inputs: Settings_Home_Faq_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role changes must be made by an authorized user with contact
            management access. You can review available roles and their
            permissions in our`)
};

/**
* | output |
* | --- |
* | "Role changes must be made by an authorized user with contact management access. You can review available roles and their permissions in our" |
*
* @param {Settings_Home_Faq_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_home_faq_2 = /** @type {((inputs?: Settings_Home_Faq_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Home_Faq_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_home_faq_2(inputs)
});